<template>
  <div class="ms-cell-editor number">
    <div
      v-show="!isSelected || readOnly || !editable"
      key="show"
      class="flex-row flex show-value"
      :class="{
        'edit-disabled': readOnly,
        'ms-editor-text': editable,
        hasError: errorProvider.isValid,
        'display-error': errorMessage && !isEditor,
        'error-border': errorMessage,
      }"
      :title="errorProvider.message"
    >
      <a v-show="!isEditor" class="editor-click" @click="$emit('editorClick', $event, col, colIndex)">
        <span
          class="editor-display"
          :class="[`text-${col.align || 'right'}`]"
          :title="[
            dataRow[col.dataField]
              ? $ms.format.formatData(dataRow[col.dataField], {
                  formatType: col.formatType,
                  decimalPlacesCustom: propsData.decimalPlacesCustom
                })
              : '',
          ]"
          >{{
            dataRow[col.dataField]
              ? $ms.format.formatData(dataRow[col.dataField], {
                  formatType: col.formatType,
                  decimalPlacesCustom: propsData.decimalPlacesCustom
                })
              : ''
          }}</span
        >
      </a>

      <ms-number
        ref="msNumber"
        v-if="isEditor && !readOnly"
        :disabled="disabled"
        v-model="cellData"
        :max="propsData.max"
        :min="propsData.min"
        :decimal-places="propsData.decimalPlaces"
        :decimalPlacesCustom="propsData.decimalPlacesCustom"
        :formatType="col.formatType"
        :preventPaste="allowCopyFromExcel"
        v-on="listeners"
      >
      </ms-number>

      <div v-show="errorMessage && !isEditor" v-tooltip="errorMessage" class="icon24 error"></div>
      <div v-show="!isEditor && customErrorMessage" v-tooltip="customErrorMessage" class="icon24 warning"></div>
    </div>
  </div>
</template>
<script>
import {defineProps, ref, defineEmits, watch, nextTick, defineExpose, inject, getCurrentInstance} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';
import LimitAmount from '@/commons/wildcards/constants/LimitAmount.js';
export default {
  name: 'MsCellNumber',
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    // Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },

    readOnly: {
      default: false,
      type: Boolean,
    },
    // disable cell hay không
    disabled: {
      default: false,
      type: Boolean,
    },
    // có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'editorClick', 'msKeydown', 'pasteInput'],

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      clearValidate,
      getValue,
    } = useCellEditor({
      emit,
      props,
    });
    watch(isEditor, (newVal, oldValue) => {
      if (!newVal) {
        emit('update:modelValue', cellData.value);
        customErrorMessage.value = '';
      } else {
        cellData.value = props.dataRow[props.col.dataField];
        nextTick(() => {
          findEditor();
        });
      }
    });

    const col = props.col;
    const rowIndex = props.rowIndex;
    const colIndex = props.colIndex;
    const isCellEditor = inject('isCellEditor');
    const allowCopyFromExcel = inject('allowCopyFromExcel');
    const customErrorMessage = ref('');

    
    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (typeof isCellEditor == 'function' && !isCellEditor(col, props.dataRow)) {
        return;
      }

      if (me.readOnly) {
        return;
      }

      if (isNaN(value)) {
        value = 0;
      }

      value = parseFloat(value);

      if (value > (me.propsData?.max || LimitAmount.Max)) {
        value = 0;
      }

      if (value < (me.propsData?.min || LimitAmount.NegativeMax)) {
        value = 0;
      }

      // Nếu giá trị không thay đổi và editor đang active thì xử lý gán lại
      if (me.$refs.msNumber && me.$refs.msNumber.getValue() == value) {
        setTimeout(() => {
          me.$refs.msNumber.setInternalValue(value);
        }, 150);
      }

      cellData.value = value;
      emit('update:modelValue', cellData.value);
    };


    return {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      clearValidate,
      getValue,
      customErrorMessage,
      allowCopyFromExcel,
      setValue
    };
  },
};
</script>
<style lang="scss" scoped>
.editor-display {
  flex: 1;
  padding: 0 6px;
}
.ms-cell-editor {
  height: 100%;
}
.ms-editor-text {
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
}
.editor-click {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.editor-click {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
